import CameraCoalizioniInfoColori from '@/data/camera-coalizioni-info-colori.json';
import PartitiListeColoriCamera from '@/data/camera-partiti-liste-colori.json';
import SenatoCoalizioniInfoColori from '@/data/senato-coalizioni-info-colori.json';
import PartitiListeColoriSenato from '@/data/senato-partiti-liste-colori.json';
import TrentinoColoriSenato from '@/data/trentino-partiti-liste-colori-senato.json';
import VdaColoriCamera from '@/data/vda-partiti-liste-colori-camera.json';
import VdaColoriSenato from '@/data/vda-partiti-liste-colori-senato.json';
import { parsePercentage } from './helpers';
import { DataLevel, StructureType } from './model';

import CameraCoalizioniInfoColori2018 from '@/data/2018-camera-coalizioni-info-colori.json';
import PartitiListeColoriCamera2018 from '@/data/2018-camera-partiti-liste-colori.json';
import SenatoCoalizioniInfoColori2018 from '@/data/2018-senato-coalizioni-info-colori.json';
import PartitiListeColoriSenato2018 from '@/data/2018-senato-partiti-liste-colori.json';

export const getPartyColor = (
  pos: number,
  type: StructureType,
  is2018 = false
) => {
  let lista =
    type === StructureType.CAMERA
      ? is2018
        ? PartitiListeColoriCamera2018
        : PartitiListeColoriCamera
      : is2018
      ? PartitiListeColoriSenato2018
      : PartitiListeColoriSenato;
  return lista.find(c => c.pos === pos)?.colore || '#D9D9D9';
};

export const getName = (
  o: any,
  cod_circ: string,
  type: StructureType,
  isCoalition: boolean,
  is2018 = false
) => {
  if (
    !is2018 &&
    ((type === StructureType.CAMERA && cod_circ === '27') ||
      (type === StructureType.SENATE && cod_circ === '2'))
  ) {
    // Valle d'Aosta
    return getVDAName(o, type);
  } else if (!is2018 && type === StructureType.SENATE && cod_circ === '21') {
    // TRENTINO Senato
    return getTrentinoName(o);
  } else {
    if (isCoalition) {
      const coalizioni =
        type === StructureType.CAMERA
          ? is2018
            ? CameraCoalizioniInfoColori2018
            : CameraCoalizioniInfoColori
          : is2018
          ? SenatoCoalizioniInfoColori2018
          : SenatoCoalizioniInfoColori;
      let coal = coalizioni.find(c => c.cod_coal === o?.pos);
      if (coal !== undefined) {
        return coal.coalizione;
      }
    }
    const partiti =
      type === StructureType.CAMERA
        ? is2018
          ? PartitiListeColoriCamera2018
          : PartitiListeColoriCamera
        : is2018
        ? PartitiListeColoriSenato2018
        : PartitiListeColoriSenato;
    return (
      partiti.find(c => c.pos === o?.pos)?.desc_lis ||
      partiti.find(c => c.cod_coal === o?.pos)?.desc_lis ||
      'N/A'
    );
  }
};

export const getFullNameCandidate = (
  o: any,
  cod_circ: string,
  type: StructureType,
  isCoalition: boolean,
  isMultiCollegio = false,
  is2018 = false
) => {
  if (
    !is2018 &&
    ((type === StructureType.CAMERA && cod_circ === '27') ||
      (type === StructureType.SENATE && cod_circ === '2'))
  ) {
    // Valle d'Aosta
    return getVDAFullNameCandidate(o, type, isMultiCollegio);
  } else if (!is2018 && type === StructureType.SENATE && cod_circ === '21') {
    // TRENTINO Senato
    return getTrentinoFullNameCandidate(o, isMultiCollegio);
  } else {
    if (isCoalition) {
      const coalizioni =
        type === StructureType.CAMERA
          ? is2018
            ? CameraCoalizioniInfoColori2018
            : CameraCoalizioniInfoColori
          : is2018
          ? SenatoCoalizioniInfoColori2018
          : SenatoCoalizioniInfoColori;
      let coal = coalizioni.find(c => c.cod_coal === o?.pos);
      if (coal !== undefined) {
        if (!isMultiCollegio && !is2018 && o.cogn !== undefined) {
          return o.nome + ' ' + o.cogn;
        }
      }
    }
    return null;
  }
};

export const getMostraDettaglio = (
  pos: number,
  type: StructureType,
  is2018 = false
) => {
  const coalizioni =
    type === StructureType.CAMERA
      ? is2018
        ? CameraCoalizioniInfoColori2018
        : CameraCoalizioniInfoColori
      : is2018
      ? SenatoCoalizioniInfoColori2018
      : SenatoCoalizioniInfoColori;

  return coalizioni.find((c: any) => c.cod_coal === pos)?.mostraDettaglio;
};

export const getCoalitionColorByPartitoListaId = (
  pos: number,
  type: StructureType,
  is2018 = false
) => {
  const partiti =
    type === StructureType.CAMERA
      ? is2018
        ? PartitiListeColoriCamera2018
        : PartitiListeColoriCamera
      : is2018
      ? PartitiListeColoriSenato2018
      : PartitiListeColoriSenato;

  let partito = partiti.find(c => c.pos === pos);
  if (is2018) {
    if (partito?.cod_coal === 2 || partito?.cod_coal === 5) {
      // coalition color only if CENTRODESTRA or CENTROSINISTRA
      const coalizioni =
        type === StructureType.CAMERA
          ? CameraCoalizioniInfoColori2018
          : SenatoCoalizioniInfoColori2018;
      return (
        coalizioni.find(c => c.cod_coal === partito?.cod_coal)?.colore ||
        '#D9D9D9'
      );
    }
  } else {
    if (
      partito?.cod_coal === 22 ||
      partito?.cod_coal === 17 ||
      partito?.cod_coal === 27
    ) {
      // coalition color only if CENTRODESTRA or CENTROSINISTRA
      const coalizioni =
        type === StructureType.CAMERA
          ? CameraCoalizioniInfoColori
          : SenatoCoalizioniInfoColori;
      return (
        coalizioni.find(c => c.cod_coal === partito?.cod_coal)?.colore ||
        '#D9D9D9'
      );
    }
  }
  return partito?.colore || '#D9D9D9';
};

export const getVDA = (pos_contr: number, type: StructureType) => {
  const lista =
    type === StructureType.CAMERA ? VdaColoriCamera : VdaColoriSenato;

  return lista.find(c => c.pos_contr === pos_contr);
};

export const getVDAColor = (pos_contr: number, type: StructureType) => {
  return getVDA(pos_contr, type)?.colore || '#D9D9D9';
};
export const getVDAName = (party: any, type: StructureType) => {
  let o = getVDA(party.pos_contr, type);
  return o?.desc_contr || 'N/A';
};

export const getVDAFullNameCandidate = (
  party: any,
  type: StructureType,
  isMultiCollegio = false
) => {
  let o = getVDA(party.pos_contr, type);
  if (!isMultiCollegio && party.cogn !== undefined) {
    return party.nome + ' ' + party.cogn;
  }
  return null;
};

export const getTrentinoColor = (pos_contr: number) =>
  TrentinoColoriSenato.find(c => c.pos_contr === pos_contr)?.colore ||
  '#D9D9D9';

export const getTrentinoName = (party: any) => {
  let o = TrentinoColoriSenato.find(c => c.pos_contr === party.pos_contr);
  return o?.desc_contr || 'N/A';
};

export const getTrentinoFullNameCandidate = (
  party: any,
  isMultiCollegio = false
) => {
  let o = TrentinoColoriSenato.find(c => c.pos_contr === party.pos_contr);
  if (!isMultiCollegio && party.cogn !== undefined) {
    return party.nome + ' ' + party.cogn;
  } else {
    return null;
  }
};

export const getCoalitionColor = (
  coalition: any,
  cod_circ: string,
  type: StructureType,
  level: DataLevel,
  is2018 = false
) => {
  if (
    !is2018 &&
    ((type === StructureType.CAMERA && cod_circ === '27') ||
      (type === StructureType.SENATE && cod_circ === '2'))
  ) {
    // Valle d'Aosta
    return getVDAColor(coalition?.pos_contr || 0, type);
  } else if (!is2018 && type === StructureType.SENATE && cod_circ === '21') {
    // TRENTINO Senato
    return getTrentinoColor(coalition?.pos_contr || 0);
  } else {
    if (level === DataLevel.COLLEGIO) {
      if (type === StructureType.CAMERA) {
        if (is2018) {
          if (coalition?.pos === 5 || coalition?.pos === 2) {
            return (
              CameraCoalizioniInfoColori2018.find(
                c => c.cod_coal === coalition?.pos
              )?.colore || '#D9D9D9'
            );
          }
        } else {
          if (coalition?.pos === 22 || coalition?.pos === 17) {
            return (
              CameraCoalizioniInfoColori.find(
                c => c.cod_coal === coalition?.pos
              )?.colore || '#D9D9D9'
            );
          }
        }
      } else if (type === StructureType.SENATE) {
        if (is2018) {
          if (coalition?.pos === 5 || coalition?.pos === 2) {
            return (
              SenatoCoalizioniInfoColori2018.find(
                c => c.cod_coal === coalition?.pos
              )?.colore || '#D9D9D9'
            );
          }
        } else {
          if (coalition?.pos === 22 || coalition?.pos === 27) {
            return (
              SenatoCoalizioniInfoColori.find(
                c => c.cod_coal === coalition?.pos
              )?.colore || '#D9D9D9'
            );
          }
        }
      }
      return getCoalitionColorByPartitoListaId(
        coalition?.liste[0].pos || 0,
        type,
        is2018
      );
    } else if (
      level === DataLevel.COMUNE &&
      coalition.pos !== 22 &&
      coalition.pos !== 17 &&
      coalition.pos !== 27
    ) {
      // coalition color only if CENTRODESTRA or CENTROSINISTRA
      return getPartyColor(coalition?.liste[0].pos || 0, type, is2018);
    } else {
      // default CIRCOSCRIZIONE
      const coalizioni =
        type === StructureType.CAMERA
          ? is2018
            ? CameraCoalizioniInfoColori2018
            : CameraCoalizioniInfoColori
          : is2018
          ? SenatoCoalizioniInfoColori2018
          : SenatoCoalizioniInfoColori;
      return (
        coalizioni.find(c => c.cod_coal === coalition.pos)?.colore || '#D9D9D9'
      );
    }
  }
};

export const generateGradientTable = <T>(list: T[], key: keyof T) => {
  if (!list.length) {
    return [];
  }

  let min = parsePercentage(`${list[0][key]}`);
  let max = parsePercentage(`${list[0][key]}`);

  list.forEach(c => {
    const check = parsePercentage(`${c[key]}`);

    if (check < min) {
      min = check;
    } else if (check > max) {
      max = check;
    }
  });

  const diff = max - min;
  const totalSteps = 7;
  const step = parseFloat((diff / totalSteps).toFixed(2));
  let prevValue = min;

  return Array.from({ length: totalSteps }).map((_, i) => {
    const opacity = parseFloat((0.15 * (i + 1)).toFixed(2));
    const value = i === totalSteps - 1 ? max : prevValue + step;
    prevValue = value;

    return {
      opacity: opacity > 1 ? 1 : opacity,
      value,
    };
  });
};
